// Единственный признак того, что мы внутри мобильного приложения, — маркер в UA.
// Версия маркера любая: «… Safari/604.1 MobileApp/1.0».
export const NATIVE_WEBVIEW_RE = /MobileApp\/[\d.]+/;

export type DevicePlatform = 'android' | 'ios';

// Остальной UA у приложения обычный (Chrome на Android, Safari на iOS),
// поэтому по нему определяем только платформу, но не факт запуска в приложении.
// iOS-UA содержит «like Mac OS X», поэтому Android проверяем первым.
const ANDROID_RE = /Android/i;
const IOS_RE = /iPhone|iPad|iPod/i;

export const CHOOSE_HOST_URL = 'alfai://choose_host';
export const GO_BACK_FROM_AUTH_URL = 'alfai://go_back_from_auth';

/** Запущены ли мы в webview мобильного приложения. Определяется строго по маркеру. */
export const isNativeWebView = (): boolean => NATIVE_WEBVIEW_RE.test(navigator.userAgent);

export const openChooseHost = (): void => {
  window.location.href = CHOOSE_HOST_URL;
};

export const openGoBackFromAuth = (): void => {
  window.location.href = GO_BACK_FROM_AUTH_URL;
};

/** Платформа устройства. Ничего не говорит о том, приложение это или браузер. */
export const getDevicePlatform = (): DevicePlatform | null => {
  const userAgent = navigator.userAgent;

  if (ANDROID_RE.test(userAgent)) {
    return 'android';
  }

  if (IOS_RE.test(userAgent)) {
    return 'ios';
  }

  return null;
};
